document.addEventListener('DOMContentLoaded', () => {
  const searchModal = document.getElementById('SearchModal');
  const searchInput = document.getElementById('SearchInput');
  const resultsContainer = document.getElementById('PredictiveSearchResults');
  const clearInputBtn = document.getElementById('ClearSearchInput');
  const closeSearchBtn = document.getElementById('CloseSearchModal');

  let debounceTimer;

  // 1. Open Modal from any search icon on the page
  document.querySelectorAll('a[href*="/search"], .search-header-btn, .header__icon--search').forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (searchModal) {
        e.preventDefault();
        searchModal.classList.add('active');
        searchModal.setAttribute('aria-hidden', 'false');
        setTimeout(() => searchInput?.focus(), 100);
      }
    });
  });

  const closeModal = () => {
    if (searchModal) {
      searchModal.classList.remove('active');
      searchModal.setAttribute('aria-hidden', 'true');
    }
  };

  closeSearchBtn?.addEventListener('click', closeModal);
  searchModal?.addEventListener('click', (e) => {
    if (e.target === searchModal) closeModal();
  });

  // 2. Fetch Predictive Search as user types
  searchInput?.addEventListener('input', (e) => {
    const query = e.target.value.trim();

    if (query.length > 0) {
      if (clearInputBtn) clearInputBtn.hidden = false;
    } else {
      if (clearInputBtn) clearInputBtn.hidden = true;
      if (resultsContainer) {
        resultsContainer.innerHTML = '<div class="search-results-placeholder"><p class="text-muted">Start typing to search products and blog posts...</p></div>';
      }
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetchPredictiveResults(query);
    }, 250);
  });

  clearInputBtn?.addEventListener('click', () => {
    if (searchInput) searchInput.value = '';
    if (clearInputBtn) clearInputBtn.hidden = true;
    searchInput?.focus();
    if (resultsContainer) {
      resultsContainer.innerHTML = '<div class="search-results-placeholder"><p class="text-muted">Start typing to search products and blog posts...</p></div>';
    }
  });

  function fetchPredictiveResults(query) {
    const rootUrl = window.Shopify ? window.Shopify.routes.root : '/';
    const requestUrl = `${rootUrl}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,article&resources[limit]=6&section_id=predictive-search-results`;

    fetch(requestUrl)
      .then(response => {
        if (!response.ok) throw new Error('Search network response failed');
        return response.text();
      })
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'html');
        const results = html.getElementById('shopify-section-predictive-search-results');
        if (results && resultsContainer) {
          resultsContainer.innerHTML = results.innerHTML;
        }
      })
      .catch(error => {
        console.error('Error fetching predictive search:', error);
      });
  }
});